import React, { useState } from 'react';
import { BiSolidDownArrow } from 'react-icons/bi';
import { Filter } from '../../Models/Filter';
import './DropdownFilter.css'
import useOuterClick from '../../Hooks/useOuterClick';

interface DropdownFilterProps {
    label: string;
    filters: Filter[];
    activeFilters: Filter[];
    className?: string
    onToggle: (filter: Filter) => void;
}

const DropdownFilter: React.FC<DropdownFilterProps> = ({
    label,
    filters,
    activeFilters,
    className,
    onToggle
}) => {
    const [open, setOpen] = useState<boolean>(false);
    const innerRef = useOuterClick(() => setOpen(false));

    // Get all actives filters
    const allActive = filters.every(f =>
        activeFilters.some(af => af.value === f.value)
    );

    // Handel select all filters
    const handleToggleAll = () => {
        if (allActive) {
            filters.forEach(f => onToggle(f));
        } else {
            filters.forEach(f => {
                const isActive = activeFilters.some(af => af.value === f.value);
                if (!isActive) {
                    onToggle(f);
                }
            });
        }
    };

    return (
        <div ref={innerRef} className={`dropdown-filter ${open ? 'open' : ''} ${className ?? ""}`}>

            <label
                role="button"
                tabIndex={0}
                onClick={() => setOpen(!open)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setOpen(!open);
                    }
                }}
            >
                <span>{label}</span>
                <BiSolidDownArrow className="arrow" />
            </label>
            <ul>
                <li>
                    <button
                        className={allActive ? 'active' : ''}
                        onClick={handleToggleAll}
                    >
                        <span>Tous</span>
                        {allActive && <span className="checkmark">✔ </span>}
                    </button>
                </li>

                {filters.map((filter) => {
                    const isActive = activeFilters.some(f => f.value === filter.value);
                    return (
                        <li key={filter.value}>
                            <button
                                className={isActive ? 'active' : ''}
                                onClick={() => onToggle(filter)}
                            >
                                <span>{filter.value.trim() === '' ? 'Non connu' : filter.value}</span>
                                {isActive && <span className="checkmark">✔ </span>}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default DropdownFilter;
